<template>
  <div
    v-if="teamStore.currentTeam && owner"
    class="no-access-to-customer"
  >
    <p>
      Sorry, you are not authorized to manage this team's billing. Please ask an Admin or the Team
      Owner.
      {{ teamStore.currentTeam.name }}'s owner is <strong>{{ ownerFullName }}</strong
      >.
    </p>
    <p>
      Team Owners and Admins are notified of any billing changes or credit expiries automatically by
      email.
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useTeamStore } from '@/pinia/useTeamStore'
import { getFullName } from '@/core/utils/formatter'

const teamStore = useTeamStore()

const owner = computed(() =>
  teamStore.currentTeam?.members.find((member) => ['admin', 'owner'].includes(member.role)),
)

const ownerFullName = computed(() => (owner.value ? getFullName(owner.value) : ''))
</script>

<style lang="scss" scoped>
.no-access-to-customer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  @include typography(md-1);
  padding-top: 20%;
  text-align: center;

  p:not(:last-child) {
    margin-bottom: 20px;
  }

  strong {
    font-weight: bold;
  }
}
</style>
